import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankBlue = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 800 800",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .bank-blue-fill {\n        fill: #002ff4;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "bank-blue-fill",
			d: "M405.88,26.6l351.7,158.03c26.92,17.07,17.38,58.49-14.01,62.26H56.52c-15.72-1.4-24.3-12.75-29.84-26.31v-13.13c3.9-12.02,9.64-20.74,21.57-25.83L394.21,26.6h11.67Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "bank-blue-fill",
			d: "M26.68,745.63v-13.13c6.23-18.22,18.09-26.32,37.13-27.77h671.02c47.81.02,51.94,63.56,4.36,68.66l-681.17-.04c-16-2.16-26.74-12.62-31.35-27.72Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "bank-blue-fill",
			d: "M688.83,311.01v306.28c44.67-6.14,58.93,54.13,15.19,66.96l-610.33-.52c-41.76-15.16-26.35-72.46,17.59-66.44v-306.28c-23.38,5.42-35.6-21.48-13.77-31.99,198.99-3.62,398.65-.52,597.89-1.56,28.32,3.99,21.62,39.18-6.57,33.55ZM280.45,311.01h-100.63v306.28h100.63v-306.28ZM451.09,617.29v-304.09l-2.19-2.19h-99.91v306.28h102.09ZM620.28,311.01h-99.91l-2.19,2.19v304.09h102.09v-306.28Z"
		})
	]
});
export default SvgBankBlue;
